// TSS vite/04 §"Endpoint paths". baseURL ya incluye /api/v1.
// Nacimientos / formulario de parto (admin-births.md).

export const birthPaths = {
    list:   ()   => 'admin/births',
    detail: (id) => `admin/births/${id}`,
};
